import { css } from '@emotion/css';
import { memo, useState } from 'react';

interface Props {
    placeholder?: string;
    note?: string;
    img?: any;
    value: string;
    onChangeText?: (_: string) => void;
    error?: string;
    typeInput?: 'PASSWORD' | 'TEXT';
}

const Register = (props: Props) => {
    const { placeholder, note, img, value, onChangeText, error, typeInput = 'TEXT' } = props;

    const [showPassword, setShowPassword] = useState(typeInput === 'PASSWORD');

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        onChangeText?.(e.target.value);
    };

    return (
        <>
            <div className={`${styles.frm__item} ${error ? styles.errorItem : ''}`}>
                <div className="itemInput">
                    <img alt="" src={img} className="imgIconInput" />
                    <input className="input" placeholder={placeholder} type={showPassword ? 'password' : undefined} value={value} onChange={handleChange} />
                </div>

                {!!note && (
                    <div className={styles.rightContent}>
                        <span className="note">{note}</span>
                        {typeInput === 'PASSWORD' && (
                            <button type="button" className={`${styles.iconVisibility} ${showPassword ? '' : 'active'}`} onClick={() => setShowPassword((v) => !v)}>
                                {showPassword ? <img alt="" src={require('assets/images/icons/reg/eye.png')} /> : <img alt="" src={require('assets/images/icons/reg/eye-hide.png')} />}
                            </button>
                        )}
                    </div>
                )}
            </div>
            <div style={{ height: '28px' }}>
                <span className={styles.error}>{error}</span>
            </div>
        </>
    );
};

export default memo(Register);

const styles = {
    frm__item: css`
        display: flex;
        justify-content: space-between;
        border-bottom: 1px #9eb7b9 solid;
        padding-bottom: 15px;
        align-items: center;

        .itemInput {
            align-items: center;
            display: flex;
            gap: 5px;
            flex: 1;
        }
        .input {
            font: inherit;
            outline: none !important;
            background-color: transparent !important;
            border: none !important;
            height: 40px;
            color: #fff;
            padding-left: 10px;
            font-family: 'UTM Avo';
            font-size: 14px;
            width: 100%;
        }
        .note {
            height: 100%;
            padding: 0 15px;
            color: gray;
            font-size: 14px;
            font-style: italic;
            display: flex;
            display: -ms-flex;
            align-items: center;
        }
        .imgIconInput {
            width: 24px;
        }
    `,
    errorItem: css`
        border-bottom: 1px #d90500 solid;
    `,
    error: css`
        padding: 0 15px;
        color: #d90500;
        font-size: 13px;
        font-style: italic;
        display: flex;
        display: -ms-flex;
        align-items: center;
        justify-content: flex-end;
        line-height: 25px;
    `,
    rightContent: css`
        display: flex;
    `,
    iconVisibility: css`
        height: 100%;
        padding: 0 15px;

        display: flex;
        align-items: center;
        justify-content: center;

        cursor: pointer;
        color: gray;
        font-size: 17px;

        background: transparent;
        border: 0;
        outline: none;

        img {
            width: 20px;
            height: 20px;
        }

        &:hover {
            img {
                opacity: 0.6;
            }
        }
    `,
};
